import {
  TROUSER_ACTIVE_FORMULA_VERSION,
  TROUSER_V3_FORMULA_VERSION,
  TROUSER_V2_FORMULA_VERSION,
} from '@/lib/patterns/trouser/siy_v1';

export const TROUSER_GEOMETRY_V2 = 'trouser_geom_v2';
export const TROUSER_GEOMETRY_V3 = 'trouser_geom_v3';
export const TROUSER_GEOMETRY_V4 = 'trouser_geom_v4';
export const TROUSER_ACTIVE_GEOMETRY_VERSION = TROUSER_GEOMETRY_V4;

export const TROUSER_FORMULA_TO_GEOMETRY = {
  siy_v1: TROUSER_GEOMETRY_V2,
  [TROUSER_V2_FORMULA_VERSION]: TROUSER_GEOMETRY_V2,
  [TROUSER_V3_FORMULA_VERSION]: TROUSER_GEOMETRY_V3,
  [TROUSER_ACTIVE_FORMULA_VERSION]: TROUSER_GEOMETRY_V4,
};

export const TROUSER_GEOMETRY_TO_FORMULA = {
  [TROUSER_GEOMETRY_V2]: TROUSER_V2_FORMULA_VERSION,
  [TROUSER_GEOMETRY_V3]: TROUSER_V3_FORMULA_VERSION,
  [TROUSER_GEOMETRY_V4]: TROUSER_ACTIVE_FORMULA_VERSION,
};

export function resolveTrouserGeometryVersionFromFormula(formulaVersion) {
  return TROUSER_FORMULA_TO_GEOMETRY[formulaVersion] || TROUSER_ACTIVE_GEOMETRY_VERSION;
}

export function resolveTrouserFormulaVersionFromGeometry(geometryVersion) {
  return TROUSER_GEOMETRY_TO_FORMULA[geometryVersion] || TROUSER_ACTIVE_FORMULA_VERSION;
}

export function migrateTrouserPatternForward(patternLike = {}) {
  const explicitGeometry = String(patternLike?.geometry_version || '').toLowerCase();
  const explicitFormula = String(patternLike?.formula_version || '').toLowerCase();
  const geometryVersion = explicitGeometry === TROUSER_GEOMETRY_V2
    ? TROUSER_GEOMETRY_V2
    : explicitGeometry === TROUSER_GEOMETRY_V3
      ? TROUSER_GEOMETRY_V3
      : explicitGeometry === TROUSER_GEOMETRY_V4
        ? TROUSER_GEOMETRY_V4
        : explicitFormula === TROUSER_V2_FORMULA_VERSION || explicitFormula === 'siy_v1'
          ? TROUSER_GEOMETRY_V2
          : explicitFormula === TROUSER_V3_FORMULA_VERSION
            ? TROUSER_GEOMETRY_V3
            : TROUSER_GEOMETRY_V4;

  return {
    ...patternLike,
    garment_type: patternLike?.garment_type || 'trouser',
    geometry_version: geometryVersion,
    formula_version: resolveTrouserFormulaVersionFromGeometry(geometryVersion),
  };
}
